import firebase from "firebase/compat/app";

const uiConfig = {
  signInFlow: "popup",
  signInOptions: [
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      buttonColor: "white",
      iconUrl: require("../assets/img/img/icon-mail.png"),
      fullLabel: "Login with Email",
    },
    {
      provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      buttonColor: "white",
      iconUrl: require("../assets/img/img/icon-phone.png"),
      fullLabel: "Login with Phone",
    },
    {
      provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      buttonColor: "white",
      fullLabel: "Login with Gmail",
    },
  ],
  tosUrl: "https://www.teamanics.com/?section=terms",

  privacyPolicyUrl: "https://www.teamanics.com/?section=privacy",

  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: () => false,
  },
};
export default uiConfig;
